import ResourceService from "./resource.service";

class ProvinceService extends ResourceService {
  static get resource() {
    return "province";
  }
}

export default ProvinceService;
